// Stack bookkeeping for the sliding panes (panes_component_controller.js).
//
// The CSS builds the stack out of DIRECT children (`.t-panes > .t-pane`) and, when idle,
// shows the last one. So "which panes are in this stack" and "which one is on top" have to
// be answered the same way here — a pane nested inside a pushed pane's content (an object
// picker, the multi-LLM picker) belongs to its own stack, not to this one.

const ACTIVE_CLASS = 't-pane--active'

// The panes of a stack, in DOM order. Direct children only.
export function stackPanes(element) {
  return Array.from(element.querySelectorAll(':scope > .t-pane'))
}

export function topPane(panes) {
  return panes[panes.length - 1]
}

// `eventTarget.closest('.t-pane')` is *not* safe on its own: when the event is
// dispatched on the stack root (arrow-left, a bubbled panes:pop / panes:replace),
// closest walks *up* and can land on a wrapping pane of a parent stack. Only a
// pane that is actually in *this* stack counts; otherwise we use the top.
export function paneFromEvent(panes, eventTarget) {
  const clicked = eventTarget?.closest?.('.t-pane')
  return clicked && panes.includes(clicked) ? clicked : topPane(panes)
}

// Which pane a pop should slide away, and which one should become active.
export function resolvePop(panes, eventTarget) {
  const pane = paneFromEvent(panes, eventTarget)
  const index = panes.indexOf(pane)
  return {
    pane,
    previousPane: index > 0 ? panes[index - 1] : undefined,
  }
}

// Move the active marker onto `pane`. Clears it from every other pane rather than just the
// first one found: two markers in one stack used to leave two panes painted in the same
// grid cell (a course's modules showing through the lessons drilled in on top of them).
export function setActivePane(panes, pane) {
  panes.forEach((p) => p.classList.remove(ACTIVE_CLASS))
  pane?.classList?.add(ACTIVE_CLASS)
}
